// extracted by mini-css-extract-plugin
export default {"mCard":"Mz-z","image":"Nz-z","imageNoBackground":"Oz-z","imageHasCategory":"Pz-z","fullWidth":"Qz-z"};